<template lang="html">
  <v-container grid-list-md pb-0 pt-0>
    <v-layout row wrap justify-center mb-3 v-if="!isCompany && !isStudentLoan">
      <div class="ta-c">
        <span class="display-1 font-weight-bold">ลงทะเบียน</span>
      </div>
    </v-layout>
    <v-layout row wrap justify-center v-if="isCompany" mb-2>
      <div class="ta-c">
        <span class="font-weight-bold" style="font-size:23px;"
          >ลงทะเบียนกรณีหน่วยงานราชการ / องค์กร / บริษัท / อื่นๆ</span
        ><br />
        <!-- <span class="font-weight-bold" style="font-size:16px;">ต้นไม้ที่ลงทะเบียนและเกียรติบัตรที่ได้รับจะถือว่าเป็นของหน่วยงานราชการ / องค์กร / บริษัท / อื่น ๆ</span> -->
      </div>
    </v-layout>
    <v-layout row wrap justify-center v-if="isStudentLoan" mb-2>
      <div class="ta-c">
        <span class="font-weight-bold" style="font-size:23px;"
          >ลงทะเบียนกรณีผู้กู้กยศ.</span
        ><br />
        <!-- <span class="font-weight-bold" style="font-size:16px;">ต้นไม้ที่ลงทะเบียนและเกียรติบัตรที่ได้รับจะถือว่าเป็นของหน่วยงานราชการ / องค์กร / บริษัท / อื่น ๆ</span> -->
      </div>
    </v-layout>
    <v-layout row wrap justify-center v-if="isCompany" mb-2>
      <v-flex md6 xs10 class="">
        <span style="font-size:18px;"
          >ต้นไม้ที่ลงทะเบียนและเกียรติบัตรที่ได้รับจะถือว่าเป็นของหน่วยงานราชการ
          / องค์กร / บริษัท / อื่น ๆ
          หากท่านประสงค์จะลงทะเบียนต้นไม้และรับเกียรติบัตรที่เป็นชื่อของท่านเอง
          โปรด<span class="underline pointer" @click="gotoPersonalRegister()"
            >ลงทะเบียนในนามบุคคล</span
          ></span
        >
      </v-flex>
    </v-layout>
    <v-form ref="form">
      <v-layout row wrap justify-center v-if="isCompany">
        <v-flex md6 xs10 class="">
          <v-text-field
            label="ชื่อหน่วยงาน/บริษัท/อื่นๆ*"
            prepend-inner-icon="business"
            solo
            hide-details
            color="blue"
            v-model="company"
            required
            :rules="nameRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isStudentLoan">
        <v-flex md6 xs10 class="">
          <v-autocomplete
            :items="listAcademy"
            label="ระบุสถานศึกษา*"
            prepend-inner-icon="school"
            solo
            hide-details
            color="blue"
            v-model="academy"
            required
            item-text="name"
            item-value="id"
            :rules="nameRules"
            return-object
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isStudentLoan">
        <v-flex md6 xs10 class="">
          <v-autocomplete
            :items="listFaculty"
            label="ระบุคณะ*"
            prepend-inner-icon="school"
            solo
            hide-details
            color="blue"
            v-model="faculty"
            required
            item-text="name"
            item-value="id"
            return-object
            :rules="checkSchool ? [] : nameRules"
            :disabled="checkSchool"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isCompany" mt-1>
        <v-flex md6 xs10>
          <span class="title font-weight-bold">รายละเอียดข้อมูลผู้แทน</span>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isStudentLoan" mt-1>
        <v-flex md6 xs10>
          <span class="title font-weight-bold">รายละเอียดข้อมูล</span>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isCompany">
        <v-flex xs10 md6>
          <div class="pa-1 orange accent-3" style="text-align:center;">
            <span class="black--text subheading"
              ><v-icon>warning</v-icon>
              โปรดทราบว่าท่านจะไม่สามารถลงทะเบียนในนามบุคคล
              โดยใช้หมายเลขประจำตัวประชาชนนี้ได้อีก</span
            >
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10 class="">
          <v-text-field
            label="รหัสบัตรประชาชน*"
            prepend-inner-icon="payment"
            solo
            hide-details
            color="blue"
            v-model="card_id"
            :mask="mask"
            required
            type="tel"
            :rules="cardRules"
            @keyup="checkCardIdDebounce"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex xs10 md6>
          <v-combobox
            :items="listTitle"
            label="พิมพ์หรือเลือกคำนำหน้าชื่อ*"
            solo
            :return-object="false"
            hide-details
            v-model="title"
            :rules="nameRules"
            :disabled="isCheckCardID ? false : true"
            required
            color="blue"
            item-text="title_name"
            prepend-inner-icon="person"
          ></v-combobox>
          <!-- <v-autocomplete
            :items="listTitle"
            label="คำนำหน้าชื่อ*"
            prepend-inner-icon="person"
            solo
            hide-details
            color="blue"
            v-model="title"
            required
            item-text="title_name"
            :rules="nameRules"
            :disabled="isCheckCardID ? false : true"
          ></v-autocomplete> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md3 xs10>
          <v-text-field
            label="ชื่อ*"
            prepend-inner-icon="person"
            solo
            hide-details
            color="blue"
            v-model="name"
            required
            :rules="nameRules"
            :disabled="isCheckCardID ? false : true"
          ></v-text-field>
        </v-flex>
        <v-flex md3 xs10>
          <v-text-field
            label="นามสกุล*"
            prepend-inner-icon="person"
            solo
            hide-details
            color="blue"
            v-model="surname"
            required
            :rules="nameRules"
            :disabled="isCheckCardID ? false : true"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10>
          <v-text-field
            label="ที่อยู่*"
            prepend-inner-icon="home"
            solo
            hide-details
            color="blue"
            v-model="address"
            required
            :rules="nameRules"
            :disabled="isCheckCardID ? false : true"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10>
          <v-text-field
            label="เบอร์โทรศัพท์*"
            prepend-inner-icon="call"
            solo
            hide-details
            color="blue"
            v-model="phone"
            type="tel"
            required
            :disabled="isCheckCardID ? false : true"
            :rules="phoneRules"
            ref="phone_ref"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10>
          <v-text-field
            label="อีเมล"
            prepend-inner-icon="email"
            solo
            hide-details
            color="blue"
            v-model="email"
            :disabled="isCheckCardID ? false : true"
            :rules="email !== '' ? emailRules : []"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex xs12 md6>
          <v-checkbox
            v-model="checkbox"
            hide-details
            required
            :disabled="isCheckCardID ? false : true"
            class="agreement"
          >
            <template v-slot:label class="grey--text font14"
              >ข้าพเจ้าทราบดีว่าการรวบรวมข้อมูลครั้งนี้เป็นไปด้วยความสมัครใจและยินยอมให้ใช้ข้อมูลของข้าพเจ้าตามที่ระบุไว้ใน
              <a
                href="#"
                @click.stop.prevent="openAgreement()"
                class="grey--text"
                >นโยบายการคุ้มครองข้อมูลส่วนบุคคล</a
              >
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap justify-center mt-3>
      <v-flex md2 xs4>
        <div class="ta-c">
          <v-btn
            color="primary"
            round
            block
            class="mx-0"
            @click="register()"
            :disabled="isCheckCardID ? false : true"
            >ลงทะเบียน</v-btn
          >
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center mt-1>
      <div class="ta-c">
        <span class="title font-weight-bold"
          >หากลงทะเบียนแล้ว โปรด<span
            class="underline pointer"
            @click="gotoLogin()"
            >เข้าสู่ระบบ</span
          ></span
        >
      </div>
    </v-layout>
    <ModalAgreement ref="ModalAgreement" />
  </v-container>
</template>

<script>
import moment from "moment";
import ModalAgreement from "@/components/ModalAgreement";
export default {
  components: {
    ModalAgreement
  },
  data() {
    return {
      disabled: true,
      items: ["นาย", "นาง", "นางสาว", "ด.ช.", "ด.ญ."],
      card_id: "",
      title: "",
      name: "",
      surname: "",
      address: "",
      phone: "",
      email: "",
      checkbox: true,
      mask: "#############",
      mask_phone: "#",
      date: "",
      nameRules: [(v) => !!v || "Name is required"],
      cardRules: [
        (v) => !!v || "Name is required",
        (v) => v.length == 13 || "Name must be less than 10 characters"
      ],
      isCheckCardID: false,
      checkCardIdDebounce: this.debounce(this.checkCardID, 500),
      emailRules: [
        (v) => /([^]).+@.+[^]+[.]+[^]/.test(v) || "E-mail must be valid"
      ],
      phoneRules: [(v) => /^[0-9]{9,10}$/.test(v) || "E-mail must be valid"],
      isCompany: false,
      isStudentLoan: false,
      company: "",
      listTitle: [],
      listCompany: [],
      company_other: "",
      academy: "",
      faculty: "",
      listAcademy: [],
      listFaculty: [],
      checkSchool: false
    };
  },
  watch: {
    academy() {
      // console.log(this.academy.name.search("นอกระบบ"));
      // console.log(this.academy.name.search("โรงเรียน"));
      var nameSchool = this.academy;
      // console.log(nameSchool);
      if (nameSchool !== undefined) {
        if (
          nameSchool.name.search("นอกระบบ") !== -1 ||
          nameSchool.name.search("โรงเรียน") !== -1
        ) {
          this.checkSchool = true;
          this.faculty = "";
        } else {
          this.checkSchool = false;
        }
      }
    }
  },
  created() {
    this.queryTitle();

    if (this.$route.path.split("/")[2] === "company") {
      this.isCompany = true;
    } else {
      this.isCompany = false;
    }
    if (this.$route.path.split("/")[2] === "studentloan") {
      this.isStudentLoan = true;
      this.queryAcademy();
      this.queryFaculty();
    } else {
      this.isStudentLoan = false;
    }
  },
  methods: {
    openAgreement() {
      this.$refs.ModalAgreement.openDialog();
    },
    moment() {
      this.date = moment().format();
    },
    gotoLogin() {
      this.$router.push("/login");
    },
    gotoPersonalRegister() {
      this.isCompany = false;
      this.$router.push("/register");
    },
    queryTitle() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryTitle")
        .then((response) => {
          this.listTitle = response.data;
        });
    },
    queryAcademy() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryAcademy")
        .then((response) => {
          this.listAcademy = response.data;
          // console.log(this.listAcademy);
        });
    },
    queryFaculty() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryFaculty")
        .then((response) => {
          this.listFaculty = response.data;
          // console.log(this.listFaculty);
        });
    },
    checkCardID() {
      if (this.card_id.length === 13) {
        var i = 0,
          sum = 0;
        for (i = 0; i < this.card_id.length - 1; i++) {
          sum += parseFloat(this.card_id[i]) * (13 - i);
        }
        if ((11 - (sum % 11)) % 10 === parseFloat(this.card_id[12])) {
          // console.log(this.card_id);
          this.axios
            .post(process.env.VUE_APP_IPFLASK + "/checkCardID", {
              card_id: this.card_id
            })
            .then((response) => {
              // console.log(response.data);
              if (response.data === "You can use this Card id") {
                this.isCheckCardID = true;
              } else if (response.data === "Card id is already use") {
                this.$swal(
                  "รหัสบัตรประชาชนนี้ถูกลงทะเบียนแล้ว",
                  "กรุณาลองใหม่อีกครั้ง",
                  "error"
                );
                this.isCheckCardID = false;
              } else {
                this.$swal(
                  "รหัสบัตรประชาชนไม่ถูกต้อง",
                  "กรุณาลองใหม่อีกครั้ง",
                  "error"
                );
                this.isCheckCardID = false;
              }
            });
        } else {
          this.isCheckCardID = false;
          this.$swal(
            "รหัสบัตรประชาชนไม่ถูกต้อง",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
        }
      } else {
        this.isCheckCardID = false;
      }
    },
    debounce(fn, time) {
      let timeout;
      return function() {
        const functionCall = () => fn.apply(this, arguments);
        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
      };
    },
    register() {
      if (this.phone !== "") {
        if (!this.$refs.phone_ref.validate()) {
          this.$swal("กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง", "", "error");
          return;
        }
      }
      // console.log(this.company);
      if (this.$refs.form.validate()) {
        //check agreement
        if (!this.checkbox) {
          this.$swal(
            "กรุณายอมรับนโยบายการคุ้มครองข้อมูลส่วนบุคคล",
            "",
            "warning"
          );
          return;
        }
        var academyName = "";
        var academyID = "";
        var facultyName = "";
        var facultyID = "";
        var campusOf = "";

        // if (!this.company && !this.isStudentLoan) {
        //   this.company = "";
        // }
        if (this.company === "อื่นๆ") {
          this.company = this.company_other;
        }

        if (this.isStudentLoan) {
          this.company = "";
          academyName = this.academy.name;
          academyID = this.academy.id;
          if (this.checkSchool) {
            facultyName = "";
            facultyID = "";
          } else {
            facultyName = this.faculty.name;
            facultyID = this.faculty.id;
          }

          if (this.academy.campus_of !== null) {
            campusOf = this.academy.campus_of;
          } else {
            campusOf = "";
          }
        }

        if (this.isCompany) {
          academyName = "";
          academyID = "";
          facultyName = "";
          facultyID = "";
          campusOf = "";
        }

        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/register", {
            card_id: this.card_id,
            title: this.title,
            name: this.name,
            surname: this.surname,
            address: this.address,
            phone: this.phone,
            email: this.email,
            company: this.company,
            academyName: academyName,
            academyID: academyID,
            facultyName: facultyName,
            facultyID: facultyID,
            campusOf: campusOf
          })
          .then((response) => {
            if (response.data === "Register Success") {
              // this.$swal('ลงทะเบียนเรียบร้อย','','success');
              this.$refs.form.reset();
              this.isCheckCardID = false;
              this.$swal({
                title: "ลงทะเบียนเรียบร้อย",
                text: "",
                type: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "OK",
                allowOutsideClick: false
              }).then((result) => {
                if (result.value) {
                  this.$router.push("/login");
                }
              });
            } else {
              this.$swal("ลงทะเบียนไม่สำเร็จ", "กรุณาลองใหม่อีกครั้ง", "error");
            }
          });
      } else {
        this.$swal("กรุณากรอกข้อมูลให้ครบถ้วน", "", "error");
      }
    }
  }
};
</script>

<style scoped>
.font14 {
  font-size: 14px !important;
}
</style>
